function openPdf(res) {
  const blob = new Blob([res], { type: "application/pdf" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  window.open(link.href);
}

function downloadFile(res) {
  const blob = new Blob([res], { type: "application/pdf" });
  //console.log(blob)

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute("download", `Title`);
  link.click();
}

export { openPdf, downloadFile };
